module.exports = __webpack_public_path__ + "img/CA.78eb5c92.jpg";